const PlusIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="13.999"
      viewBox="0 0 14 13.999"
    >
      <path
        id="Form_4"
        data-name="Form 4"
        d="M1416,226v-5h-5a1,1,0,1,1,0-2h5v-5a1,1,0,0,1,2,0v5h5a1,1,0,1,1,0,2h-5v5a1,1,0,0,1-2,0Z"
        transform="translate(-1409.999 -213)"
    
      />
    </svg>
  );
};

export default PlusIcon;
